import { SelectItem } from 'primeng/api';
import { UtilityService } from './../services/utility.service';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'specialistField',
})
export class SpecialistFieldPipe implements PipeTransform {
  private specialistFields: SelectItem[];

  constructor(private utilityService: UtilityService) {
    this.specialistFields = this.utilityService.getSpecialistField();
  }

  /**
   * get the specialistField code number and return it as a strinng vlaue
   * @param value number
   * @param args
   * @returns label string
   */
  transform(value: number, ..._args: unknown[]): any {
    for (const i of this.specialistFields) {
      if (i.value === value) {
        return i.label;
      }
    }
  }
}
